import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {DjPsychoGameAssets} from "../DjPsychoGameAssets";
import {DjPsycho} from "../DjPsycho";
import {TimelineLite} from "gsap";
import {DjPsychoSound} from "../sound/DjPsychoSound";

export class DjPsychoTotalMultiplier extends PIXI.Container implements StageLayer {

    private _multiplier: PIXI.BitmapText;
    private _x1: PIXI.Sprite;

    constructor() {
        super();
        this.name = "DjPsychoTotalMultiplier";

        this.init();
    }

    private _value: number = 1;

    get value(): number {
        return this._value;
    }

    public setMultiplierInstantly(val: number): void {
        if (val > 1) {
            this._multiplier.visible = true;
            this._x1.visible = false;

            this._value = val;
            this.setValueOnMultiplier(this._value);
        }
    }

    public setMultiplier(val: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();

        if (val === this._value) {
            return tl;
        }


        if (val > 1) {
            tl.add(() => {
                this._multiplier.visible = true;
                this._x1.visible = false;

                this.setValueOnMultiplier(this._value);
            });

            for (let i: number = this._value + 1, ctr: number = 0; i <= val; i++, ctr++) {
                tl.to(this._multiplier.scale, {
                    duration: 4 / 30,
                    x: 1.3,
                    y: 1.3
                });
                tl.add(() => {
                    // #153
                    DjPsycho.soundPlayer.playSound(DjPsychoSound.MULTIPLIER_UP_SOUNDS[ctr]);

                    this.setValueOnMultiplier(i);
                });
                tl.to(this._multiplier.scale, {
                    duration: 4 / 30,
                    x: 1,
                    y: 1
                });
                tl.to(this, {
                    duration: 6 / 30
                });
            }
        }

        tl.add(() => {
            this._value = val;
        });

        if (val === 1) {
            this.turnOff();
        }

        return tl;
    }

    public turnOff(): void {
        this._x1.visible = true;
        this._value = 1;
        this._multiplier.text = "";
        this._multiplier.visible = false;
    }

    private init(): void {
        this._multiplier = new PIXI.BitmapText("x1", {
            fontName: DjPsychoGameAssets.BITMAP_FONT_TOTAL_MULTIPLIER,
            fontSize: 24,
            maxWidth: 100
        });
        this._multiplier.visible = false;

        this._x1 = new PIXI.Sprite(DjPsycho.assetLoader.getTextures("Knob_X1")[0]);
        this._x1.anchor.set(0.5);
        this._x1.position.set(630, 182);

        this.addChild(this._x1, this._multiplier);
    }

    private setValueOnMultiplier(val: number): void {
        this._multiplier.fontSize = 24;
        this._multiplier.text = "x" + val;

        while (this._multiplier.textWidth > this._multiplier.maxWidth) {
            this._multiplier.fontSize--;
        }
        this._multiplier.pivot.set(this._multiplier.textWidth / 2, this._multiplier.textHeight / 2);
        this._multiplier.position.set(630, 170);
    }
}